module.exports = __webpack_public_path__ + "img/2.91d3e24c.jpg";